/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
import { Checkbox, HStack, Text, Stack, SimpleGrid, Divider, Button } from '@chakra-ui/core';
import React, { useCallback } from 'react';
import { MdPersonAdd, MdRemoveRedEye } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import colors from '../../../../../styles/colors';
import { Recruiter } from '../types';
import { CountChip } from './CountChip';

interface RecruiterItemProps {
  recruiter: Recruiter;
  isChecked: boolean;
  onToggle: (id: string) => void;
  onOnly: (id: string) => void;
  style?: React.CSSProperties;
}

function RecruiterItemComponent({ recruiter, isChecked, onToggle, onOnly, style }: RecruiterItemProps): JSX.Element {
  const { t } = useTranslation('moniterByRecruiters');
  const fullname = `${recruiter?.firstName ?? ''} ${recruiter?.lastName ?? ''}`;
  const handleToggle = useCallback(() => {
    onToggle(recruiter.id);
  }, [onToggle, recruiter.id]);

  return (
    <HStack
      spacing={1}
      justify="space-between"
      align="center"
      px={4}
      py={1}
      style={style}
      _hover={{
        backgroundColor: colors.table.hoverBg,
        borderRadius: 'md',
        '& > .only-action': {
          display: 'inline-block',
        },
      }}
    >
      <Checkbox
        size="lg"
        isChecked={isChecked}
        onChange={handleToggle}
        width="100%"
        borderRadius="md"
        flexGrow={1}
        alignItems="flex-start"
        data-testid={`recruiter-checkbox-${recruiter.id}`}
        sx={{
          '& > .chakra-checkbox__label': { flexGrow: 1 },
        }}
      >
        {/* <Avatar name={fullname} bg="blue.500" fontWeight="bold" color="white" /> */}
        <Stack ml={2} spacing={1} align="flex-start" position="relative">
          <Text
            color="gray.700"
            fontSize="md"
            lineHeight="100%"
            width="100%"
            isTruncated
            noOfLines={1}
            maxW={200}
            data-testid="recruiter-name"
          >
            {fullname}
          </Text>
          <SimpleGrid templateColumns="60px 20px 60px" alignItems="center">
            <CountChip
              size={16}
              count={recruiter.assignedPositionCount /* istanbul ignore next */ ?? 0}
              title={t('positionRecruiters.filter.following')}
              Icon={MdPersonAdd}
              data-testid="followed-count"
            />
            <Divider orientation="vertical" height={3} />
            <CountChip
              size={16}
              count={recruiter.watchedPositionCount /* istanbul ignore next */ ?? 0}
              title={t('positionRecruiters.filter.watching')}
              Icon={MdRemoveRedEye}
              data-testid="watched-count"
            />
          </SimpleGrid>
        </Stack>
      </Checkbox>
      <Button
        size="xs"
        variant="outline"
        className="only-action"
        display="none"
        fontWeight="normal"
        px={2}
        minW="auto"
        tabIndex={-1}
        data-testid={`only-button-${recruiter.id}`}
        onMouseDown={(e) => e.preventDefault()}
        onClick={(e) => {
          e.stopPropagation();
          onOnly(recruiter.id);
        }}
      >
        {t('only')}
      </Button>
    </HStack>
  );
}

export const RecruiterItem = React.memo(RecruiterItemComponent);
